import { render, staticRenderFns } from "./ObservationTwo.vue?vue&type=template&id=76fbe714&scoped=true&"
import script from "./ObservationTwo.vue?vue&type=script&lang=js&"
export * from "./ObservationTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fbe714",
  null
  
)

export default component.exports